import {
  FormControlLabel,
  FormHeader2,
  FormHeader1,
  FormRow,
  OnClick,
  Switch,
  TemporaryDrawer,
  Button,
} from '@csp/csp-web-ui';
import * as React from 'react';
import { FC } from 'react';
import { useBoolean } from '@csp/fe-hooks';
import { useDebugAnalyticsTrackerService } from '@csp/csp-web-analytics';
import { toDateAndTimeNumber, ZonedDateTimeFactory } from '@csp/csp-common-date-util';
import { DownloadFileService } from '../../../common/service/DownloadFileService';
import { isDebugCmsModeActive, toggleDebugCmsMode } from '../../../common/util/debugCmsUtil';
import { StaticContentService } from '../../../common/service/StaticContentService';
import { useCanDebugCms } from '../hook/useCanDebugCms';
import { useCanDebugAnalytics } from '../hook/useCanDebugAnalytics';

type Props = {
  open: boolean;
  onClose: OnClick;
};

type OnSwitch = (event: React.SyntheticEvent, checked: boolean) => void;

export const SettingsDrawerContainer: FC<Props> = props => {
  const debugDrawerBlock = StaticContentService.getPublicBlock('webHcpSettings', 'drawer');

  const [cmsChecked, , , toggleCmsChecked] = useBoolean(isDebugCmsModeActive());
  const canDebugCms = useCanDebugCms();
  const handleToggleCmsDebugMode: OnSwitch = () => {
    toggleCmsChecked();
    toggleDebugCmsMode();
    window.location.reload();
  };

  const debugAnalyticsTrackerService = useDebugAnalyticsTrackerService();
  const canDebugAnalytics = useCanDebugAnalytics();
  const handleToggleAnalyticsDebugMode: OnSwitch = (_e, checked) => {
    debugAnalyticsTrackerService.setIsEnabled(checked);
  };

  return (
    <TemporaryDrawer header={debugDrawerBlock.header.text} {...props}>
      <FormHeader1>{debugDrawerBlock.header.debugCmsMode.text}</FormHeader1>

      {canDebugCms && (
        <>
          <FormHeader2>{debugDrawerBlock.header.cms.text}</FormHeader2>
          <FormRow>
            <FormControlLabel
              control={<Switch color="primary" onChange={handleToggleCmsDebugMode} checked={cmsChecked} />}
              display="block"
              label={debugDrawerBlock.body.cmsDescription.text}
            />
          </FormRow>
          <FormRow divider />
        </>
      )}
      {canDebugAnalytics && (
        <>
          <FormHeader2>{debugDrawerBlock.header.analytics.text}</FormHeader2>
          <FormRow>
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  onChange={handleToggleAnalyticsDebugMode}
                  checked={debugAnalyticsTrackerService.isEnabled}
                />
              }
              display="block"
              label={debugDrawerBlock.body.analyticsDescription.text}
            />
          </FormRow>
          <FormRow>
            <Button
              variant="contained"
              onClick={() => {
                const blob = new Blob([debugAnalyticsTrackerService.toJSON()]);
                const now = toDateAndTimeNumber(ZonedDateTimeFactory.now());
                DownloadFileService.download({ data: blob, filename: `${now}-analytics-events`, format: 'json' });
              }}
            >
              {debugDrawerBlock.button.exportAnalytics.label}
            </Button>
            <Button sx={{ ml: 1 }} variant="outlined" onClick={debugAnalyticsTrackerService.clear}>
              {debugDrawerBlock.button.clearAnalytics.label}
            </Button>
          </FormRow>

          <FormRow divider py={2} />
        </>
      )}
    </TemporaryDrawer>
  );
};
